<template>
  <mdb-container>
    <EditUnionMember/>
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import EditUnionMember from "@/components/EditUnionmember.vue";

export default {
  name: "AddUnionmember",
  components: {
    mdbContainer,
    EditUnionMember
  },
  data() {
    return {

    };
  },
};
</script>

<style></style>
